import { useState, useEffect } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import CommonAppointmentCalendar from "./CommonAppointmentCalendar";
import PropTypes from "prop-types";
import { useDispatch, useSelector } from "react-redux";
import { fetchAppointmentsLeadAction } from "../../../store/actions/AppointmentActions";
import Swal from "sweetalert2";

export const ServiceCallerAppointmentCalendar = ({
  leadId,
  patientId,
  doctorId,
}) => {
  const dispatch = useDispatch();
  const [selectedDate, setSelectedDate] = useState(null);
  
  // ✅ Safe selector
  const { appointments = [] } = useSelector(
    (state) => state.appointmentState || {}
  );

  // ✅ Fetch appointments
  useEffect(() => {
    if (patientId) {
      dispatch(fetchAppointmentsLeadAction(leadId, patientId));
    } else if (leadId) {
      dispatch(fetchAppointmentsLeadAction(leadId, null));
    }
  }, [leadId, patientId, dispatch]);

  // ✅ Check if there's a pending payment appointment
  // const hasPendingPaymentAppointment = () => {
  //   const pendingAppointment = appointments.find(
  //     (appt) => 
  //       appt.is_payment === "No" && 
  //       appt.appointment_status?.toLowerCase() !== "cancel" &&
  //       appt.appointment_status?.toLowerCase() !== "cancelled"
  //   );
  //   return !!pendingAppointment;
  // };

  // ✅ Check if appointment already exists (not cancelled)
  // const hasAppointment = appointments.some(
  //   (a) => 
  //     (String(a.lead_id) === String(leadId) || String(a.patient_id) === String(patientId)) &&
  //     a.appointment_status?.toLowerCase() !== "cancel" &&
  //     a.appointment_status?.toLowerCase() !== "cancelled"
  // );

  return (
    <div>
           <div className="card mb-4 shadow-none mt-2">
          <div className="row align-items-end p-3">
            
            {/* Date Picker */}
            <div className="col-md-4">
              <label className="form-label fw-semibold text-dark mb-3">
                Select Preferred Date:
              </label>

              <div className="position-relative">
                <DatePicker
                  selected={selectedDate}
                  onChange={(date) => setSelectedDate(date)}
                  minDate={new Date()}
                  dateFormat="MMMM d, yyyy"
                  placeholderText="Choose a date"
                  showPopperArrow={false}
                  popperPlacement="bottom-start"
                  className="form-control form-control-lg ps-5 pe-5"
                />

                {/* Calendar Icon */}
                <i
                  className="fa fa-calendar position-absolute"
                  style={{
                    left: "15px",
                    top: "50%",
                    transform: "translateY(-50%)",
                    pointerEvents: "none",
                    fontSize: "18px",
                    color: "#6c757d",
                  }}
                />

                {/* Clear Button */}
                {selectedDate && (
                  <i
                    className="fa fa-times position-absolute"
                    onClick={() => setSelectedDate(null)}
                    style={{
                      right: "20px",
                      top: "50%",
                      transform: "translateY(-50%)",
                      fontSize: "18px",
                      color: "#6c757d",
                      cursor: "pointer",
                      zIndex: 11,
                    }}
                  />
                )}
              </div>
            </div>

            {/* Confirm Button */}
            <div className="col-md-2 d-flex align-items-end">
              <button
                className="btn btn-outline-primary w-100"
                style={{ height: "60px" }}
                onClick={() => {
                  if (!selectedDate) {
                    alert("Please select a date");
                    return;
                  }

                  // CRITICAL: Block event dispatch if reschedule is in progress
                  if (window.isRescheduling) {
                    console.log("[v0] Event dispatch blocked - reschedule in progress");
                    return;
                  }

                  window.dispatchEvent(
                    new CustomEvent("serviceCallerBookClick", {
                      detail: { selectedDate },
                    })
                  );
                }}
              >
                Confirm
              </button>
            </div>

          </div>
        </div>
      {/* Calendar always visible */}
      <CommonAppointmentCalendar
        leadId={leadId}
        patientId={patientId}
        doctorId={doctorId}
        currentLeadId={leadId}
        currentPatientId={patientId}
        module="service_caller"
        appointmentType="service_caller"
        selectedDate={selectedDate}
        openFromServiceCaller={true}
      />

      {/* Hide booking UI if appointment already exists OR has pending payment */}
      {/* {!hasAppointment && !hasPendingPaymentAppointment() && ( */}
   
      {/* )} */}

      {/* Show pending payment warning if exists */}
      {/* {hasPendingPaymentAppointment() && (
        <div className="alert alert-warning mt-3" role="alert">
          <i className="fas fa-exclamation-triangle me-2"></i>
          <strong>Payment Required:</strong> You have an existing appointment with pending payment. Please complete the payment before booking a new appointment.
        </div>
      )} */}
    </div>
  );
};

ServiceCallerAppointmentCalendar.propTypes = {
  leadId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  patientId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  doctorId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
};

export default ServiceCallerAppointmentCalendar;
